/* 2026 WilderdijkDynamics. No customer IDs or private lists in browser storage. */
(function(){
  'use strict';
  var configEl=document.querySelector('[data-wd-wishlist-config]');
  if(!configEl)return;
  var cfg=JSON.parse(configEl.textContent), labels=cfg.labels, emailLabels=cfg.emailLabels;
  var session='', pendingButton=null, linkToken='';
  try{session=sessionStorage.getItem('wd-list-session')||'';}catch(e){}
  function setSession(value){session=value;try{if(value)sessionStorage.setItem('wd-list-session',value);else sessionStorage.removeItem('wd-list-session');}catch(e){}}
  var page=document.querySelector('[data-wd-wishlist-page]');
  var notice=document.querySelector('[data-wd-wishlist-notice]');
  var status=page&&page.querySelector('[data-wd-wishlist-status]');
  var retry=page&&page.querySelector('[data-wd-wishlist-retry]');
  var items=[],token='',loading=null,loaded=false,noticeTimer;
  var selected=new Set(),quantities=new Map(),bulkBusy=false;
  var bulkLabels=cfg.bulk||{};
  function productUrl(item){return cfg.root.replace(/\/?$/,'/')+'products/'+encodeURIComponent(item.handle)+'?variant='+encodeURIComponent(item.variantId);}
  function imageUrl(value){if(!value)return '';try{var url=new URL(value,location.origin);return url.protocol==='https:'&&(url.origin===location.origin||url.hostname==='cdn.shopify.com'||url.hostname.endsWith('.shopifycdn.com'))?url.href:'';}catch(e){return '';}}
  function el(tag,text){var node=document.createElement(tag);if(text)node.textContent=text;return node;}
  function show(message){
    clearTimeout(noticeTimer);notice.textContent=message;notice.hidden=false;
    noticeTimer=setTimeout(function(){notice.hidden=true;},6000);
  }
  async function request(url,options){
    var opts=Object.assign({credentials:'same-origin',cache:'no-store'},options||{});
    opts.headers=Object.assign({Accept:'application/json'},opts.headers||{});
    if(session)opts.headers['X-WD-List-Session']=session;
    opts.signal=AbortSignal.timeout(15000);
    var response=await fetch(url,opts);
    if(response.status===401){setSession('');var authError=new Error('EMAIL_REQUIRED');authError.email=true;throw authError;}
    if(!(response.headers.get('content-type')||'').includes('application/json'))throw new Error('WISHLIST_UNAVAILABLE');
    if(!response.ok){var problem=await response.json();throw new Error(problem.error||'WISHLIST_UNAVAILABLE');}
    return response.json();
  }
  async function load(){
    if(!session&&!cfg.loggedIn){var e=new Error('EMAIL_REQUIRED');e.email=true;throw e;}
    if(loading)return loading;
    loading=(async function(){
      var next='',all=[];
      do{
        var data=await request(cfg.endpoint+(next?'?after='+encodeURIComponent(next):''));
        all=all.concat(data.items||[]);token=data.csrfToken;next=data.next;
      }while(next);
      items=all;loaded=true;selected.forEach(function(id){if(!items.some(function(item){return String(item.variantId)===id;}))selected.delete(id);});render();
    })();
    try{await loading;}finally{loading=null;}
  }
  function buttonVariant(button){
    if(button.dataset.wdForm){var form=document.getElementById(button.dataset.wdForm);var input=form&&form.querySelector('[name="id"]');return input&&input.value;}
    return button.dataset.wdVariant;
  }
  function syncButtons(){
    document.querySelectorAll('[data-wd-save-part]').forEach(function(button){
      var saved=items.some(function(item){return item.variantId===String(buttonVariant(button));});
      var label=saved?labels.saved:labels.save;
      button.setAttribute('aria-pressed',String(saved));
      if(button.textContent!==label)button.textContent=label;
    });
    document.querySelectorAll('[data-wd-wishlist-count]').forEach(function(count){var value=String(items.length);if(count.textContent!==value)count.textContent=value;count.hidden=!items.length;});
  }
  function render(){
    syncButtons();
    if(!page)return;
    var container=page.querySelector('[data-wd-wishlist-items]');
    var search=page.querySelector('[data-wd-wishlist-search]').value.trim().toLocaleLowerCase();
    var visible=items.filter(function(item){return (item.title+' '+item.sku+' '+item.variantTitle).toLocaleLowerCase().includes(search);});
    container.replaceChildren();status.textContent=items.length?visible.length+' / '+items.length:labels.empty;
    retry.hidden=true;
    visible.forEach(function(item){
      var card=el('article');card.className='wd-wishlist-card';
      var id=String(item.variantId);
      var checkLabel=el('label');checkLabel.className='wd-wishlist-select';
      var check=el('input');check.type='checkbox';check.dataset.wdSelectPart=id;check.checked=selected.has(id);check.disabled=bulkBusy;
      checkLabel.append(check,document.createTextNode(bulkLabels.select));card.append(checkLabel);
      var media=el('a');media.href=productUrl(item);media.tabIndex=-1;media.setAttribute('aria-hidden','true');
      var img=el('img');img.src=imageUrl(item.image)||cfg.placeholder;img.alt='';img.loading='lazy';img.width=280;img.height=160;
      img.addEventListener('error',function(){if(img.dataset.fallback)return;img.dataset.fallback='1';img.src=cfg.placeholder;});media.append(img);card.append(media);
      card.append(el('h2',item.title.split(' | ')[0]),el('p',item.sku));
      if(item.variantTitle&&item.variantTitle!=='Default Title')card.append(el('p',item.variantTitle));
      var link=el('a',labels.view);link.href=productUrl(item);card.append(link);
      var qtyLabel=el('label',bulkLabels.quantity);qtyLabel.className='wd-wishlist-quantity';
      var qty=el('input');qty.type='number';qty.min='1';qty.max='99999';qty.step='1';qty.value=String(quantities.get(id)||1);qty.dataset.wdPartQuantity=id;qty.disabled=bulkBusy;qtyLabel.append(qty);card.append(qtyLabel);
      var remove=el('button',labels.remove);remove.type='button';remove.dataset.wdRemovePart=item.variantId;remove.disabled=bulkBusy;card.append(remove);container.append(card);
    });
    syncBulk();
  }
  async function start(){
    if(status)status.textContent=labels.loading;
    if(retry)retry.hidden=true;
    try{await load();}catch(error){
      items=[];selected.clear();syncButtons();syncBulk();if(page)page.querySelector('[data-wd-wishlist-items]').replaceChildren();
      if(status){status.textContent=error.email?emailLabels.open:labels.error;retry.hidden=Boolean(error.email);}
      if(error.email&&session==='')updateAccessActions();
    }
  }
  document.addEventListener('click',async function(event){
    var button=event.target.closest('[data-wd-save-part], [data-wd-remove-part]');
    if(!button)return;
    event.preventDefault();
    if(button.disabled||bulkBusy)return;
    var removing=button.hasAttribute('data-wd-remove-part');
    var id=button.dataset.wdRemovePart||button.dataset.wdVariant;
    if(button.dataset.wdForm){var form=document.getElementById(button.dataset.wdForm);var input=form&&form.querySelector('[name="id"]');id=input&&input.value;}
    if(!/^[1-9]\d*$/.test(id||'')){show(labels.error);return;}
    if(!session&&!cfg.loggedIn){openEmail(button);return;}
    button.disabled=true;
    try{
      // Refresh token before each write; account changes in another tab must not cross identities.
      await load();
      if(!removing)removing=items.some(function(item){return item.variantId===String(id);});
      var result=await request(cfg.endpoint,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-WD-Wishlist-Token':token},body:JSON.stringify({action:removing?'remove':'save',variantId:String(id)})});
      items=items.filter(function(item){return String(item.variantId)!==String(id);});
      if(removing){selected.delete(String(id));quantities.delete(String(id));}
      if(result.saved)items.push(result.item);
      render();show(removing?labels.remove:labels.saved);
    }catch(error){if(error.email){items=[];loaded=false;syncButtons();openEmail(button);dialogError.textContent=emailLabels.expired;dialogError.hidden=false;}else show(labels.error);}finally{button.disabled=false;}
  });
  function syncBulk(){
    if(!page)return;
    var bar=page.querySelector('[data-wd-wishlist-bulk]');if(!bar)return;
    bar.hidden=!items.length;
    page.querySelector('[data-wd-selected-count]').textContent=bulkLabels.selected+' '+selected.size;
    page.querySelectorAll('[data-wd-bulk-cart],[data-wd-bulk-quote]').forEach(function(button){button.disabled=bulkBusy||!selected.size;});
    var checks=Array.from(page.querySelectorAll('[data-wd-select-part]'));
    var count=checks.filter(function(input){return selected.has(input.dataset.wdSelectPart);}).length;
    var all=page.querySelector('[data-wd-select-all]');all.checked=checks.length>0&&count===checks.length;all.indeterminate=count>0&&count<checks.length;all.disabled=bulkBusy||!checks.length;
  }
  function setBulkBusy(busy){
    bulkBusy=busy;page.setAttribute('aria-busy',String(busy));
    page.querySelectorAll('[data-wd-select-part],[data-wd-part-quantity],[data-wd-remove-part]').forEach(function(input){input.disabled=busy;});syncBulk();
  }
  async function addSelectionToCart(){
    if(bulkBusy||!selected.size)return;
    if(document.documentElement.classList.contains('wd-prices-hidden')){
      if(window.WDPricing)window.WDPricing.show();return;
    }
    setBulkBusy(true);
    var controller=new AbortController(),timer=setTimeout(function(){controller.abort();},30000);
    try{
      await load();
      var chosen=items.filter(function(item){return selected.has(String(item.variantId));});
      if(!chosen.length)throw new Error('EMPTY');
      var root=cfg.root.replace(/\/?$/,'/'),products=new Map();
      for(var item of chosen){
        var product=products.get(item.handle);
        if(!product){
          var response=await fetch(root+'products/'+encodeURIComponent(item.handle)+'.js',{credentials:'same-origin',signal:controller.signal});
          if(!response.ok)throw new Error('UNAVAILABLE');product=await response.json();products.set(item.handle,product);
        }
        var variant=product.variants.find(function(v){return String(v.id)===String(item.variantId);});
        if(!variant||!variant.available){show(item.title+' '+bulkLabels.unavailable);return;}
      }
      var result=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',signal:controller.signal,headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:chosen.map(function(item){return {id:String(item.variantId),quantity:quantities.get(String(item.variantId))||1};})})});
      if(!result.ok)throw new Error('ADD_FAILED');
      await result.json();selected.clear();render();
      document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
      document.dispatchEvent(new CustomEvent('wd:cart-added',{bubbles:true}));
    }catch(error){
      if(error.email){items=[];selected.clear();quantities.clear();loaded=false;render();updateAccessActions();show(emailLabels.expired);}
      else show(error.name==='AbortError'?bulkLabels.pending:bulkLabels.failed);
    }
    finally{clearTimeout(timer);setBulkBusy(false);}
  }
  function quoteSelection(){
    if(bulkBusy||!selected.size)return;
    var chosen=items.filter(function(item){return selected.has(String(item.variantId));});
    if(chosen.length>100){show(labels.error);return;}
    try{
      sessionStorage.setItem('wd-quote-selection',JSON.stringify({created:Date.now(),variants:chosen.map(function(item){return String(item.variantId);}),products:chosen.map(function(item){return {variantId:String(item.variantId),handle:item.handle,quantity:quantities.get(String(item.variantId))||1};})}));
      location.assign(cfg.quoteUrl);
    }catch(e){show(labels.error);}
  }
  if(page){
    page.addEventListener('change',function(event){
      var input=event.target;if(bulkBusy)return;
      if(input.matches('[data-wd-select-part]')){if(input.checked)selected.add(input.dataset.wdSelectPart);else selected.delete(input.dataset.wdSelectPart);}
      if(input.matches('[data-wd-select-all]'))page.querySelectorAll('[data-wd-select-part]').forEach(function(check){check.checked=input.checked;if(input.checked)selected.add(check.dataset.wdSelectPart);else selected.delete(check.dataset.wdSelectPart);});
      if(input.matches('[data-wd-part-quantity]')){var value=Math.min(99999,Math.max(1,parseInt(input.value,10)||1));input.value=String(value);quantities.set(input.dataset.wdPartQuantity,value);}
      syncBulk();
    });
    page.querySelector('[data-wd-bulk-cart]').addEventListener('click',addSelectionToCart);
    page.querySelector('[data-wd-bulk-quote]').addEventListener('click',quoteSelection);
  }
  document.addEventListener('change',function(){if(loaded)setTimeout(syncButtons,0);});
  var syncQueued=false;
  new MutationObserver(function(changes){
    var added=changes.some(function(change){return Array.from(change.addedNodes).some(function(node){return node.nodeType===1&&(node.matches('[data-wd-save-part]')||node.querySelector('[data-wd-save-part]'));});});
    if(!added||syncQueued)return;syncQueued=true;queueMicrotask(function(){syncQueued=false;syncButtons();});
  }).observe(document.body,{childList:true,subtree:true});

  var dialog=document.querySelector('[data-wd-email-dialog]');
  var dialogForm=dialog.querySelector('[data-wd-email-form]');
  var dialogTitle=dialog.querySelector('h2');
  var dialogDescription=dialog.querySelector('[data-wd-email-description]');
  var dialogConfirm=dialog.querySelector('[data-wd-email-confirm]');
  var dialogError=dialog.querySelector('[data-wd-email-error]');
  var busy=false;
  function updateAccessActions(){
    document.querySelectorAll('[data-wd-close-list]').forEach(function(b){b.hidden=!session;});
    document.querySelectorAll('[data-wd-open-email]').forEach(function(b){b.hidden=Boolean(session)||cfg.loggedIn;});
  }
  function openEmail(button){
    pendingButton=button||null;
    dialogForm.hidden=Boolean(linkToken);dialogConfirm.hidden=!linkToken;dialogError.hidden=true;
    dialogTitle.textContent=emailLabels.title;dialogDescription.textContent=linkToken?emailLabels.confirmText:emailLabels.intro;
    if(!dialog.open)dialog.showModal();
    if(window.WDContactEmail)window.WDContactEmail.fill(dialogForm.querySelector('input'));
    if(linkToken)dialogConfirm.focus();else dialogForm.querySelector('input').focus();
  }
  dialog.querySelector('[data-wd-email-close]').addEventListener('click',function(){dialog.close();});
  dialog.addEventListener('click',function(event){if(event.target!==dialog)return;var r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
  dialog.addEventListener('cancel',function(event){if(busy)event.preventDefault();});
  async function emailAction(body){
    var setup=await request(cfg.endpoint+'/email');
    if(!setup.enabled)throw new Error('EMAIL_PAUSED');
    return request(cfg.endpoint+'/email',{method:'POST',headers:{'Content-Type':'application/json','X-WD-Wishlist-Token':setup.csrfToken},body:JSON.stringify(body)});
  }
  function emailError(error){dialogError.textContent=error.message==='EMAIL_COOLDOWN'?emailLabels.cooldown:emailLabels.error;dialogError.hidden=false;}
  dialogForm.addEventListener('submit',async function(event){
    event.preventDefault();if(window.WDContactEmail)window.WDContactEmail.validatePhone(dialogForm.elements.phone);if(busy||!dialogForm.reportValidity())return;
    busy=true;var submit=dialogForm.querySelector('button');submit.disabled=true;dialogError.hidden=true;
    try{
      var id=pendingButton?buttonVariant(pendingButton):null;
      if(pendingButton&&!/^[1-9]\d*$/.test(id||''))throw new Error('INVALID_VARIANT');
      var email=dialogForm.querySelector('input').value.trim();
      await emailAction({action:'request',email:email,phone:dialogForm.elements.phone.value.trim(),variantId:id});
      if(window.WDContactEmail)window.WDContactEmail.remember(email);
      dialogForm.hidden=true;dialogTitle.textContent=emailLabels.sent;dialogDescription.textContent=emailLabels.sentText;dialogTitle.focus();
    }catch(e){emailError(e);}finally{busy=false;submit.disabled=false;}
  });
  dialogConfirm.addEventListener('click',async function(){
    if(busy||!linkToken)return;busy=true;dialogConfirm.disabled=true;dialogError.hidden=true;
    try{
      var result=await emailAction({action:'confirm',linkToken:linkToken});
      if(!result.sessionToken)throw new Error('EMAIL_UNAVAILABLE');
      setSession(result.sessionToken);linkToken='';loaded=false;await load();updateAccessActions();dialog.close();show(labels.saved);
    }catch(e){emailError(e);dialogForm.hidden=false;dialogConfirm.hidden=true;linkToken='';dialogDescription.textContent=emailLabels.expired;}
    finally{busy=false;dialogConfirm.disabled=false;}
  });
  document.addEventListener('click',function(event){
    if(event.target.closest('[data-wd-open-email]'))openEmail();
    if(event.target.closest('[data-wd-close-list]')){if(window.WDContactEmail)window.WDContactEmail.forget();dialogForm.querySelector('input').value='';document.querySelectorAll('[data-wd-restock-form] input[name="email"]').forEach(function(input){input.value='';});setSession('');items=[];selected.clear();quantities.clear();loaded=false;render();updateAccessActions();start();}
  });
  if(location.hash.indexOf('#wd-list=')===0){
    try{linkToken=decodeURIComponent(location.hash.slice(9));}catch(e){linkToken='';}
    history.replaceState(null,'',location.pathname+location.search);
    if(linkToken)openEmail();
  }
  updateAccessActions();

  if(!page&&(cfg.loggedIn||session))load().catch(function(){});
  if(page){
    page.querySelector('[data-wd-wishlist-search]').addEventListener('input',render);
    retry.addEventListener('click',start);if(!linkToken)start();
    window.addEventListener('pageshow',function(event){if(event.persisted)start();});
    document.addEventListener('visibilitychange',function(){if(!document.hidden&&loaded)start();});
  }
})();
